// Reviewed cosmetic merchandising only; exact variants from 2026-10-09T18:37:17.443Z.
// Generated by scripts/build-skin-compass-curation.mjs. Never uses catalog health claims as display copy.
globalThis.SkinCompassCatalog = [
  {
    "key": "grape",
    "handle": "rote-weintrauben-seife-haarseife-porenstraffung-tonic",
    "variantId": "57812936458627",
    "names": [
      "Rote-Weintrauben-Seife",
      "Savon au raisin rouge",
      "Red grape soap",
      "صابون العنب الأحمر"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "oily",
      "balanced"
    ],
    "wishes": [
      "clear",
      "gentle"
    ],
    "scents": [
      "fruity"
    ]
  },
  {
    "key": "nettle",
    "handle": "petersilie-brennnessel-seife-haarseife-beruhigende-wirkung-glanz",
    "variantId": "57813315584387",
    "names": [
      "Petersilie-Brennnessel-Seife",
      "Savon persil-ortie",
      "Parsley & nettle soap",
      "صابون البقدونس والقراص"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "oily",
      "balanced"
    ],
    "wishes": [
      "clear",
      "gentle"
    ],
    "scents": [
      "herbal"
    ]
  },
  {
    "key": "berry",
    "handle": "himbeere-brombeerenseife-anti-aging-haarseife",
    "variantId": "57813701362051",
    "names": [
      "Himbeer-Brombeer-Seife",
      "Savon framboise-mûre",
      "Raspberry & blackberry soap",
      "صابون التوت"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "balanced",
      "demanding"
    ],
    "wishes": [
      "rich"
    ],
    "scents": [
      "fruity"
    ]
  },
  {
    "key": "strawberry",
    "handle": "erdbeere-joghurtseife-anti-aging-akne-peeling",
    "variantId": "57813785084291",
    "names": [
      "Erdbeer-Joghurt-Seife",
      "Savon fraise-yaourt",
      "Strawberry & yogurt soap",
      "صابون الفراولة والزبادي"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "balanced",
      "oily"
    ],
    "wishes": [
      "rich"
    ],
    "scents": [
      "fruity"
    ]
  },
  {
    "key": "apricot",
    "handle": "aprikosen-honigseife-antibakteriell-extra-pflegend",
    "variantId": "57813835186563",
    "names": [
      "Aprikosen-Honig-Seife",
      "Savon abricot-miel",
      "Apricot & honey soap",
      "صابون المشمش والعسل"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "balanced",
      "demanding"
    ],
    "wishes": [
      "rich"
    ],
    "scents": [
      "fruity"
    ]
  },
  {
    "key": "papaya",
    "handle": "papayaseife-antioxidant-vitamin-power-seife",
    "variantId": "57813334688131",
    "names": [
      "Papaya-Seife",
      "Savon à la papaye",
      "Papaya soap",
      "صابون البابايا"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "balanced",
      "demanding"
    ],
    "wishes": [
      "rich",
      "gentle"
    ],
    "scents": [
      "fruity"
    ]
  },
  {
    "key": "lavender",
    "handle": "lavendel-neroliseife-haarseife-beruhigende-wirkung",
    "variantId": "57813643362691",
    "names": [
      "Lavendel-Neroli-Seife",
      "Savon lavande-néroli",
      "Lavender & neroli soap",
      "صابون اللافندر والنيرولي"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "dry",
      "balanced"
    ],
    "wishes": [
      "gentle"
    ],
    "scents": [
      "floral"
    ]
  },
  {
    "key": "bay",
    "handle": "lorbeerseife-haarseife-rasierseife",
    "variantId": "57813612593539",
    "names": [
      "Lorbeer-Seife",
      "Savon au laurier",
      "Laurel soap",
      "صابون الغار"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "balanced",
      "oily"
    ],
    "wishes": [
      "clear"
    ],
    "scents": [
      "herbal",
      "woody"
    ]
  },
  {
    "key": "patchouli",
    "handle": "patchouli-zedernseife-haarseife-schuppenflechte",
    "variantId": "57813332230531",
    "names": [
      "Patchouli-Zeder-Seife",
      "Savon patchouli-cèdre",
      "Patchouli & cedar soap",
      "صابون الباتشولي والأرز"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "balanced",
      "demanding"
    ],
    "wishes": [
      "rich"
    ],
    "scents": [
      "woody"
    ]
  },
  {
    "key": "vanilla",
    "handle": "vanille-seife-antioxidant-gleichgewicht-der-haut",
    "variantId": "57812861550979",
    "names": [
      "Vanille-Seife",
      "Savon à la vanille",
      "Vanilla soap",
      "صابون الفانيليا"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "oily",
      "balanced"
    ],
    "wishes": [
      "gentle",
      "rich"
    ],
    "scents": []
  },
  {
    "key": "avocado",
    "handle": "avocado-seife-anti-aging-extra-pflege-sehr-trockene-haut",
    "variantId": "57813830599043",
    "names": [
      "Avocado-Seife",
      "Savon à l’avocat",
      "Avocado soap",
      "صابون الأفوكادو"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "balanced",
      "demanding"
    ],
    "wishes": [
      "rich"
    ],
    "scents": [
      "fruity"
    ]
  },
  {
    "key": "olive",
    "handle": "olivenfrucht-seife-haarseife-vitamin-e-trockene-haut",
    "variantId": "57813428863363",
    "names": [
      "Olivenfrucht-Seife",
      "Savon à l’olive",
      "Olive soap",
      "صابون الزيتون"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "balanced"
    ],
    "wishes": [
      "rich",
      "gentle"
    ],
    "scents": [
      "woody"
    ]
  },
  {
    "key": "calendula",
    "handle": "ringelblumen-seife-akne-pilze-rasierseife",
    "variantId": "57813213741443",
    "names": [
      "Ringelblumen-Seife",
      "Savon au calendula",
      "Calendula soap",
      "صابون الآذريون"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "oily",
      "balanced"
    ],
    "wishes": [
      "clear"
    ],
    "scents": [
      "floral",
      "woody"
    ]
  },
  {
    "key": "vetiver",
    "handle": "viola-vetiver-seife-akne-antiaging",
    "variantId": "57812861354371",
    "names": [
      "Viola-Vetiver-Seife",
      "Savon violette-vétiver",
      "Violet & vetiver soap",
      "صابون البنفسج والفيتيفر"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "oily",
      "demanding",
      "balanced"
    ],
    "wishes": [
      "clear",
      "rich"
    ],
    "scents": [
      "floral",
      "woody"
    ]
  },
  {
    "key": "seaweed",
    "handle": "meeresalgen-seife-haarseife",
    "variantId": "57813449310595",
    "names": [
      "Meeresalgen-Seife",
      "Savon aux algues",
      "Seaweed soap",
      "صابون الطحالب"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "oily",
      "balanced"
    ],
    "wishes": [
      "clear",
      "gentle"
    ],
    "scents": [
      "herbal",
      "woody"
    ]
  },
  {
    "key": "almond",
    "handle": "mandel-cracker-seife-anti-aging",
    "variantId": "57813538963843",
    "names": [
      "Mandel-Seife",
      "Savon à l’amande",
      "Almond soap",
      "صابون اللوز"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "demanding",
      "balanced"
    ],
    "wishes": [
      "rich"
    ],
    "scents": []
  },
  {
    "key": "aloe",
    "handle": "aloe-vera-seife-antiaging-sonnenbrand",
    "variantId": "57813842100611",
    "names": [
      "Aloe-Vera-Seife",
      "Savon à l’aloe vera",
      "Aloe vera soap",
      "صابون الألوفيرا"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "balanced"
    ],
    "wishes": [
      "gentle"
    ],
    "scents": [
      "fruity",
      "woody"
    ]
  },
  {
    "key": "fig",
    "handle": "frische-feigen-seife",
    "variantId": "57813772960131",
    "names": [
      "Feigen-Seife",
      "Savon à la figue",
      "Fig soap",
      "صابون التين"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "balanced",
      "demanding"
    ],
    "wishes": [
      "clear",
      "gentle"
    ],
    "scents": [
      "fruity"
    ]
  },
  {
    "key": "eucalyptus",
    "handle": "eukalyptus-mohnseife",
    "variantId": "57813778661763",
    "names": [
      "Eukalyptus-Mohn-Seife",
      "Savon eucalyptus-pavot",
      "Eucalyptus & poppy soap",
      "صابون الأوكالبتوس والخشخاش"
    ],
    "regions": [
      "hands",
      "body"
    ],
    "needs": [
      "oily",
      "balanced"
    ],
    "wishes": [
      "clear"
    ],
    "scents": [
      "herbal"
    ]
  },
  {
    "key": "cocoaOrange",
    "handle": "orange-schokolade-zimt-seife",
    "variantId": "57813425783171",
    "names": [
      "Orange-Schokolade-Zimt-Seife",
      "Savon orange-chocolat-cannelle",
      "Orange, chocolate & cinnamon soap",
      "صابون البرتقال والشوكولاتة والقرفة"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "oily",
      "balanced"
    ],
    "wishes": [
      "rich"
    ],
    "scents": [
      "fruity"
    ]
  },
  {
    "key": "cucumber",
    "handle": "gurken-bluten-seife",
    "variantId": "57813750120835",
    "names": [
      "Gurkenblüten-Seife",
      "Savon fleur de concombre",
      "Cucumber blossom soap",
      "صابون زهر الخيار"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "oily",
      "balanced"
    ],
    "wishes": [
      "gentle",
      "clear"
    ],
    "scents": [
      "herbal"
    ]
  },
  {
    "key": "mint",
    "handle": "schwarzes-meer",
    "variantId": "57813312143747",
    "names": [
      "Pfefferminz-Seife",
      "Savon à la menthe",
      "Mint soap",
      "صابون النعناع"
    ],
    "regions": [
      "hair",
      "hands",
      "body"
    ],
    "needs": [
      "balanced"
    ],
    "wishes": [
      "clear"
    ],
    "scents": [
      "herbal"
    ]
  },
  {
    "key": "mandarin",
    "handle": "mandarinen-seife",
    "variantId": "57813554790787",
    "names": [
      "Mandarinen-Seife",
      "Savon à la mandarine",
      "Mandarin soap",
      "صابون اليوسفي"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "balanced"
    ],
    "wishes": [
      "clear",
      "gentle"
    ],
    "scents": [
      "fruity"
    ]
  },
  {
    "key": "pomegranate",
    "handle": "granatapfel-jojoba-seife",
    "variantId": "57813755265411",
    "names": [
      "Granatapfel-Jojoba-Seife",
      "Savon grenade-jojoba",
      "Pomegranate & jojoba soap",
      "صابون الرمان والجوجوبا"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "dry",
      "demanding",
      "balanced"
    ],
    "wishes": [
      "rich",
      "gentle"
    ],
    "scents": [
      "fruity"
    ]
  },
  {
    "key": "whiteClay",
    "handle": "weisser-ton-shea-seife",
    "variantId": "57812649902467",
    "names": [
      "Weisser-Ton-Shea-Seife",
      "Savon argile blanche-karité",
      "White clay & shea soap",
      "صابون الطين الأبيض والشيا"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "dry",
      "balanced"
    ],
    "wishes": [
      "gentle"
    ],
    "scents": [
      "floral"
    ]
  },
  {
    "key": "donkey",
    "handle": "eselmilch-seife",
    "variantId": "57813780201859",
    "names": [
      "Eselmilch-Seife",
      "Savon au lait d’ânesse",
      "Donkey milk soap",
      "صابون حليب الأتان"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "dry",
      "demanding",
      "balanced"
    ],
    "wishes": [
      "gentle",
      "rich"
    ],
    "scents": []
  },
  {
    "key": "tripleButter",
    "handle": "organische-vollreinigungs-weisse-schokoladen-brownie-korperseife",
    "variantId": "57813797372291",
    "names": [
      "Shea-Mango-Kakao-Seife",
      "Savon karité-mangue-cacao",
      "Shea, mango & cocoa soap",
      "صابون الشيا والمانجو والكاكاو"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "dry",
      "demanding",
      "balanced"
    ],
    "wishes": [
      "rich",
      "gentle"
    ],
    "scents": []
  },
  {
    "key": "cocoaShea",
    "handle": "organische-vollreinigung-schokoladen-brownie-korperseife",
    "variantId": "57813671018883",
    "names": [
      "Kakao-Shea-Seife",
      "Savon cacao-karité",
      "Cocoa & shea soap",
      "صابون الكاكاو والشيا"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "demanding",
      "balanced"
    ],
    "wishes": [
      "rich"
    ],
    "scents": []
  },
  {
    "key": "pine",
    "handle": "usistadt-seife-langenthaler-seife-kieferol-duschseife",
    "variantId": "57812863713667",
    "names": [
      "Kiefernadel-Seife",
      "Savon aux aiguilles de pin",
      "Pine needle soap",
      "صابون إبر الصنوبر"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "balanced"
    ],
    "wishes": [
      "clear",
      "gentle"
    ],
    "scents": [
      "herbal",
      "woody"
    ]
  },
  {
    "key": "chamomile",
    "handle": "kamillenseife-trockene-haut-heilend-haarseife-1",
    "variantId": "57976939708803",
    "names": [
      "Kamillen-Seife",
      "Savon à la camomille",
      "Chamomile soap",
      "صابون البابونج"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "dry",
      "balanced"
    ],
    "wishes": [
      "gentle"
    ],
    "scents": [
      "floral",
      "woody"
    ]
  },
  {
    "key": "nettle",
    "handle": "petersilie-brennnessel-seife-haarseife-beruhigende-wirkung-glanz",
    "variantId": "57813315584387",
    "names": [
      "Petersilie-Brennnessel-Seife",
      "Savon persil-ortie",
      "Parsley & nettle soap",
      "صابون البقدونس والقراص"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "oily",
      "balanced"
    ],
    "wishes": [
      "rich"
    ],
    "scents": [
      "herbal"
    ],
    "gapOnly": true
  },
  {
    "key": "berry",
    "handle": "himbeere-brombeerenseife-anti-aging-haarseife",
    "variantId": "57813701362051",
    "names": [
      "Himbeer-Brombeer-Seife",
      "Savon framboise-mûre",
      "Raspberry & blackberry soap",
      "صابون التوت"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "dry",
      "balanced",
      "demanding"
    ],
    "wishes": [
      "rich",
      "gentle"
    ],
    "scents": [
      "fruity"
    ],
    "gapOnly": true
  },
  {
    "key": "baby",
    "handle": "babyseife-extra-pflegend-trockene-haut",
    "variantId": "57813830402435",
    "names": [
      "Kamille-Olivenöl-Babyseife",
      "Savon bébé camomille-olive",
      "Chamomile & olive baby soap",
      "صابون الأطفال بالبابونج والزيتون"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "dry",
      "balanced"
    ],
    "wishes": [
      "gentle",
      "rich"
    ],
    "scents": [
      "floral"
    ],
    "gapOnly": true
  },
  {
    "key": "amber",
    "handle": "amber",
    "variantId": "57813840363907",
    "names": [
      "Amber-Seife",
      "Savon à l’ambre",
      "Amber soap",
      "صابون العنبر"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "dry",
      "demanding",
      "balanced"
    ],
    "wishes": [
      "rich",
      "gentle"
    ],
    "scents": [
      "woody"
    ],
    "gapOnly": true
  },
  {
    "key": "propolis",
    "handle": "unbenannt-26-juni_18-59",
    "variantId": "57813304050051",
    "names": [
      "Propolis-Seife",
      "Savon à la propolis",
      "Propolis soap",
      "صابون البروبوليس"
    ],
    "regions": [
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "oily",
      "dry",
      "balanced"
    ],
    "wishes": [
      "clear",
      "gentle"
    ],
    "scents": [
      "floral",
      "fruity"
    ],
    "gapOnly": true
  },
  {
    "key": "argan",
    "handle": "arganseife-anti-aging-haarseife",
    "variantId": "57813832794499",
    "names": [
      "Argan-Seife",
      "Savon à l’argan",
      "Argan soap",
      "صابون الأركان"
    ],
    "regions": [
      "hair",
      "face",
      "hands",
      "body"
    ],
    "needs": [
      "dry",
      "demanding",
      "balanced"
    ],
    "wishes": [
      "rich",
      "gentle"
    ],
    "scents": [
      "floral"
    ],
    "gapOnly": true
  }
];
